import React from "react";

import { useField, FieldInputProps, FieldHelperProps } from "formik";
import { Column } from "components/Layout";
import { ToggleButtons } from "./ToggleButtons";

interface LabelToggleButtonsProps {
  name: string;
  label?: string;
  options: Array<{ label: string; value: string | number }>;
  tooltip?: string;
  disabled?: boolean;
  maxOptions?: number;
}

export const LabelToggleButtons: React.FC<LabelToggleButtonsProps> = ({
  name,
  label,
  options,
  tooltip,
  disabled = false,
  maxOptions = 12,
}) => {
  const [field, , helpers]: [
    FieldInputProps<(string | number)[]>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Formik field meta type
    any,
    FieldHelperProps<(string | number)[]>,
  ] = useField<(string | number)[]>(name);

  // Show only the first x options that are marked as quick_select
  const quickSelectOptions = options.slice(0, maxOptions);

  const handleGroupChange = (
    event: React.MouseEvent<HTMLElement>,
    newValues: (string | number)[] | null,
  ) => {
    helpers.setValue(newValues || []);
    helpers.setTouched(true, false);
  };

  if (quickSelectOptions.length === 0) {
    return null;
  }

  const selectedValues = field.value || [];

  return (
    <Column fullWidth>
      <ToggleButtons
        name={name}
        label={label}
        tooltip={tooltip}
        options={quickSelectOptions}
        value={selectedValues}
        onChange={handleGroupChange}
        disabled={disabled}
      />
    </Column>
  );
};
